<template>
  <div>
    <px-view-header title="Carrinho" title-class="font-weight-bold" :breadcrumbs="breadcrumbs"/>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div class="mt-5" v-if="!loading">
      <px-listagem-carrinho :carrinhos="itens"
                            :remover-carrinho="removerCarrinho"
                            :remover-produto="removerProduto"
                            :finalizar="finalizar"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  GET_ITENS, REMOVE_ITEM, REMOVE_CARRINHO,
} from '@/store/carrinho/actions.type';
import { map, uniq } from 'lodash';
import ListagemCarrinho from './ListagemCarrinho.vue';

export default {
  name: 'Carrinho',
  data() {
    return {
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Carrinho' },
      ],
    };
  },
  computed: {
    ...mapGetters('carrinho', ['itens', 'loading']),
  },
  methods: {
    ...mapActions('carrinho', {
      getItens: GET_ITENS,
      removeItem: REMOVE_ITEM,
      removeCarrinho: REMOVE_CARRINHO,
    }),
    removerProduto(id) {
      this.removeItem(id);
    },
    removerCarrinho(id) {
      this.removeCarrinho(id);
    },
    isSelecaoMoedasValida(carrinhos) {
      const carrinhosSelecionados = carrinhos
        .filter(c => c.produtos.find(p => p.$$selecionado));
      const moedas = carrinhosSelecionados.map(c => c.respostaCotacao.moeda);
      return uniq(moedas).length <= 1;
    },
    finalizar(fornecedor) {
      const isSelecaoMoedasValida = this.isSelecaoMoedasValida(fornecedor.carrinhos);
      if (!isSelecaoMoedasValida) {
        this.$toast('Selecione produtos com a mesma moeda para finalizar o carrinho', { color: 'error' });
        return;
      }
      const carrinhosProdutos = fornecedor.carrinhos
        .flatMap(c => c.produtos.filter(p => p.$$selecionado));

      if (!carrinhosProdutos.length) {
        this.$toast('Selecione ao menos um produto para finalizar o carrinho', { color: 'error' });
        return;
      }

      this.$router.push({
        name: 'main.carrinho.finalizacao',
        params: {
          id: map(carrinhosProdutos, 'id')
            .join(','),
        },
      });
    },
  },
  created() {
    this.getItens();
  },
  components: { pxListagemCarrinho: ListagemCarrinho },
};
</script>

<style scoped>

</style>
